// CMS API 通过 /cms/api/ 路径访问
const API_PRODUCTION = 'https://api.boxiaotu.cn'
const USE_LOCAL = false
const VITE_API_BASE = USE_LOCAL
  ? 'http://localhost:3001/api'
  : API_PRODUCTION + '/cms/api'
export { VITE_API_BASE }
export default VITE_API_BASE
